@if (productLocatorIsActive$ | async) {
<div>
    @if ( (productLocatorFacade.hasError$ | async) === true || (loadGeoLibrariesService.hasError$ | async) === true ) {
    <h-message-block [showBackground]="false" [type]="'error'">
        <ng-container i18n="@@hermes.catalog.product_pages.find-in-store-error-service-unavailable">
            Something went wrong. Fear not, we will be right back.
        </ng-container>
    </h-message-block>
    } @if (productLocatorFacade.productHasNoShopsStock$ | async) {
    <h-message-block [showBackground]="false" [type]="'error'">
        {{ "hermes.product_locator.find-in-store-error-no-stock" | translate }}
    </h-message-block>
    } @if (!product?.stock?.ecom) {

    <h-sticky-wrapper>
        <ng-container *ngTemplateOutlet="stock"></ng-container>
    </h-sticky-wrapper>

    } @else {

    <ng-container *ngTemplateOutlet="stock"></ng-container>

    }

    <!-- white design for the button because there is AddToCart button-->
    <ng-template #stock>
        <h-action-button
            #angularLocateInStoreButtonInStock
            [class.transparent-background]="transparentBackground"
            class="locate-in-store-button flex-button paragraph-medium"
            [size]="'large'"
            [bold]="false"
            (pressed)="launchProductLocator()"
            [id]="'angular-locate-in-store-button-in-stock'"
            [name]="'find-in-store'"
            [loading]="
                (productLocatorFacade.loading$ | async) === true ||
                (loadGeoLibrariesService.isLoading$ | async) === true
            "
            [dataTestId]="'Find in store'"
            i18n="@@hermes.catalog.product_pages.find-in-store-button">
            Find in store
        </h-action-button>
    </ng-template>
</div>
}
